import React, { Component } from 'react';
import { connect } from 'react-redux'

import ResponsiveComponent from './components/responsive/responsive';

import DesktopErrorComponent from './components/responsive/desktop/error/error';
import MobileErrorComponent from './components/responsive/mobile/error/error';
import DesktopSplashComponent from './components/responsive/desktop/splash/splash';
import MobileSplashComponent from './components/responsive/mobile/splash/splash';
import DesktopHomeComponent from './components/responsive/desktop/home/home';
import MobileHomeComponent from './components/responsive/mobile/home/home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { updateApplicationConfiguration } from './utils/api/applicationApiProxy.js';
import { updateSnoozePropertyConfiguration } from './utils/api/snoozePropertyApiProxy.js';
import { loadUserById } from './utils/api/userApiProxy';

const queryString = require('query-string');

const logger = require('./utils/logger/logger');
const stateManager = require('./utils/state/stateManager.js');
const configurationManager = require('./utils/config/configurationManager');
const fatalErrorAction = require('./utils/state/actions/error/fatalErrorAction');

const storageUtil = require('./utils/storage/storageUtil');
const stringUtil = require('./utils/string/stringUtil.js');
const splitioClient = require('./utils/splitio/splitioClient');
const basketUtil = require('./utils/basket/basketUtil');
const constants = require('./utils/domain/constants');
const currentComponentAction = require('./utils/state/actions/component/currentComponentAction');

class App extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.isLoaded = false;

        this.initializeHost();
    }

    render()
    {
        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().fatalError))
        {
            return <ResponsiveComponent
                mobile={<MobileErrorComponent />}
                desktop={<DesktopErrorComponent />} />
        }

        if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().applicationId))
        {
            var store = stateManager.getStore();
            store.dispatch(fatalErrorAction.createAction("Application is accessed without application id"));
            return null;
        }

        if (!this.state.isLoaded)
        {
            return this.renderLoading();
        }

        return this.renderComponent();
    }

    renderComponent()
    {
        document.title = stateManager.getStore().getState().applicationTitle;

        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().themeId))
            document.documentElement.setAttribute('data-theme', stateManager.getStore().getState().themeId)

        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().favIconUrl))
        {
            var favicon = document.getElementById("favicon");
            favicon.href = stateManager.getStore().getState().favIconUrl;
        }

        var state = stateManager.getStore().getState();
        if (state.currentComponent !== "confirmation")
        {
            if (basketUtil.isCurrentBasketForPaymentOverPhone())
                state.currentComponent = "basket";
            else
                state.currentComponent = "store";
        }

        return <div>
            <ResponsiveComponent
                desktop={<DesktopHomeComponent />}
                mobile={<MobileHomeComponent />}
            />
            <ToastContainer />
        </div>
    }

    renderLoading()
    {
        var store = stateManager.getStore();

        storageUtil.initializeStorage()
            .then(async _ =>
            {
                try
                {
                    await configurationManager.loadConfiguration();
                    await updateApplicationConfiguration();
                    logger.resetGlobalContext();

                    await updateSnoozePropertyConfiguration();

                    const stripeReturn = this.getStripeReturnParams();
                    if (stripeReturn && basketUtil.restoreBasketFromStripeReturn())
                    {
                        await this.redirectToPaymentSuccessPage(stripeReturn, store);
                    }

                    const state = stateManager.getStore().getState();
                    if (basketUtil.isCurrentBasketForPaymentOverPhone())
                    {
                        if (!state.basket.isPaymentOverPhoneApplicableToSale)
                        {
                            store.dispatch(fatalErrorAction.createAction("The payment has either been collected or sale has been cancelled!"));
                            return null;
                        }

                        const user = await loadUserById(stateManager.getStore().getState().basket.order.customerId);
                        state.user =
                        {
                            ...user,
                            isUserVerified: true,
                            isUserRegistered: true,
                        }
                    }

                    this.state.isLoaded = true;

                    this.setState({});
                }
                catch (error)
                {
                    store.dispatch(fatalErrorAction.createAction(error));
                }

            }, error =>
            {
                store.dispatch(fatalErrorAction.createAction(error));
            });

        return <ResponsiveComponent
            desktop={<DesktopSplashComponent />}
            mobile={<MobileSplashComponent />}
        />
    }

    async redirectToPaymentSuccessPage(stripeReturn, store)
    {
        const state = stateManager.getStore().getState();
        const basket = state.basket;
        const logContext = 
        { 
            orderNumber: basket?.order?.number, 
            orderId: basket?.order?.id, 
            propertyId: state.propertyId, 
            franchisorId: state.franchisorId 
        };

        const shouldRedirectWithoutOrderSubmission = await this.redirectWithoutOrderSubmission();
        if (shouldRedirectWithoutOrderSubmission)
        {
            logger.info('Redirecting to payment success without order submission (feature flag on)', logContext);
            await this.redirectToPaymentSuccessPageWithoutSubmittingBasket(stripeReturn, store);
        }
        else
        {
            logger.info('Redirecting to payment success after submitting basket to API (feature flag off)', logContext);
            await this.redirectToPaymentSuccessPageAfterSubmittingBasketToApi(stripeReturn, store);
        }
    }

    async redirectWithoutOrderSubmission()
    {
        try
        {
            const config = configurationManager.getAppConfig();
            if (!config.rmsFrontendSplitIoApiKey)
                return false;

            const client = await splitioClient.getSplitClient();
            const treatment = client.getTreatment('rms_web_app_skip_order_submission_after_payment');
            return treatment === 'on';
        }
        catch (error)
        {
            logger.warn('Split.io feature flag rms_web_app_skip_order_submission_after_payment unavailable, defaulting to false', { error });
            return false;
        }
    }

    async redirectToPaymentSuccessPageAfterSubmittingBasketToApi(stripeReturn, store)
    {
        try
        {
            const state = stateManager.getStore().getState();
            const basket = state.basket;
            logger.info(`Payment successful for order number: ${basket.order.number}`,
                {
                    franchisorId: state.franchisorId,
                    franchiseeId: state.franchiseeId,
                    propertyId: state.propertyId,
                    orderNumber: basket.order.number,
                    orderId: basket.order.id,
                    amount: basketUtil.getTotalBasketPrice()
                }
            );

            basketUtil.applyStripeRedirectResult(stripeReturn.payment_intent, stripeReturn.redirect_status);
            await basketUtil.submitOrder();
            store.dispatch(currentComponentAction.createAction("confirmation"));
        }
        catch (orderError)
        {
            // Payment succeeded but confirmation display failed
            store.dispatch(fatalErrorAction.createAction(
                'Your payment was processed but we encountered an issue displaying your confirmation. ' +
                'Please contact support with payment reference: ' + stripeReturn.payment_intent
            ));
        }
        finally
        {
            basketUtil.clearStripeReturnBasket();
        }
    }

    async redirectToPaymentSuccessPageWithoutSubmittingBasket(stripeReturn, store)
    {
        try
        {
            const state = stateManager.getStore().getState();
            const basket = state.basket;
            state.lastOrderNumber = basket.order.number;

            logger.info(`Payment successful for order number: ${basket.order.number}`,
                {
                    franchisorId: state.franchisorId,
                    franchiseeId: state.franchiseeId,
                    propertyId: state.propertyId,
                    orderNumber: basket.order.number,
                    orderId: basket.order.id,
                    amount: basketUtil.getTotalBasketPrice()
                }
            );

            store.dispatch(currentComponentAction.createAction("confirmation"));
        }
        catch (orderError)
        {
            // Payment succeeded but order submission failed
            store.dispatch(fatalErrorAction.createAction(
                'Your payment was processed but we encountered an issue creating your order. ' +
                'Please contact support with payment reference: ' + stripeReturn.payment_intent
            ));
        }

        finally
        {
            basketUtil.clearStripeReturnBasket();
        }
    }

    initializeHost()
    {
        this.initializeHostViaSearch();
        if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().applicationId))
            this.initializeHostViaHash();
    }

    initializeHostViaSearch()
    {
        if (this.props.location != null && this.props.location.search != null)
        {
            var parsedQueryString = queryString.parse(this.props.location.search);
            stateManager.getStore().getState().applicationId = parsedQueryString.applicationId;
        }
    }

    initializeHostViaHash()
    {
        if (window == null || window.location == null)
            return;
        var hash = window.location.hash || '';
        var search = window.location.search || '';
        var parsedHash = {};
        var parsedSearch = queryString.parse(search);
        if (!stringUtil.isStringNullOrEmpty(hash) && hash.includes("?"))
        {
            var rawQueryString = hash.split("?")[1];
            parsedHash = queryString.parse(rawQueryString);
        }
        var params = Object.assign({}, parsedSearch, parsedHash);

        if (params.applicationId)
        {
            stateManager.getStore().getState().applicationId = params.applicationId;
            stateManager.getStore().getState().currentMode = constants.applicationMode.webApp;
        }
        else if (params.paymentLinkId)
        {
            stateManager.getStore().getState().paymentLinkId = params.paymentLinkId;
            stateManager.getStore().getState().applicationId = params.paymentLinkId;
            stateManager.getStore().getState().currentMode = constants.applicationMode.overPhonePayment;
        }
    }

    getStripeReturnParams()
    {
        if (typeof window === 'undefined' || !window.location)
        {
            return null;
        }

        var search = queryString.parse(window.location.search || '');
        var hash = window.location.hash || '';
        var parsedHash = {};

        if (hash.includes("?"))
        {
            parsedHash = queryString.parse(hash.split("?")[1]);
        }

        var params = Object.assign({}, search, parsedHash);
        if (params.payment_intent && params.redirect_status)
        {
            return { 
                payment_intent: params.payment_intent, 
                redirect_status: params.redirect_status 
            };
        }

        return null;
    }
}

const mapStateToProps = state => 
{
    return {
        fatalError: state.fatalError,
    }
}

export default connect(mapStateToProps)(App)
